import '../scss/kibernetes-custom.scss'

import KIBERNETES_VERSION from './version'

window.KIBERNETES_VERSION = KIBERNETES_VERSION

import KibernetesObject from './plugins/kibernetes_utils';
import KibernetesCookieBar from './plugins/kibernetes_cookies';
import KibernetesSpinner from './plugins/kibernetes_spinner';
import KibernetesNotification from './plugins/kibernetes_notification';
import KibernetesCarousel from './plugins/kibernetes_carousel';
import KibernetesValutazioni from './plugins/kibernetes_valutazioni';
import KibernetesSharing from './plugins/kibernetes_sharing';
import KibernetesPagination from './plugins/kibernetes_pagination';


export function createCarousel(element,conf) {
  return new KibernetesCarousel(element,conf);
}

export function createValutazioni(valutazione) {
  return new KibernetesValutazioni(valutazione);
}

export function createObject( params={} ) {
  return new KibernetesObject( params );
}

export function createSpinner() {
  return new KibernetesSpinner();
}

export function manageCookieBar( selector, ga, wai, at ) {
  return new KibernetesCookieBar( selector, ga, wai, at );
}

export function createNotification( title='Titolo', msg='Errore', stato='error', svg='' ) {
  return new KibernetesNotification( title, msg, stato, svg );
}

export function share( page, title, service ) {
  if ( !page ) {
    page = document.location.href;
  }
  if ( !title ) {
    title = document.title;
  }
  return new KibernetesSharing().share( page, title, service );
}

export function createPager( url, elenco='div.elenco', tot=0, pageSize=10 ) {
  return new KibernetesPagination( url, elenco, tot, pageSize );
}
